import React from 'react';
import { OneFortySix } from '../parts/svg.jsx';
import { ShopNewsletterForm as NewsletterForm } from '../parts/NewsletterForm';

const Footer = props => {
  return <footer className="page__footer">
    <div className="column column--location">
      Berlin<br />
      <br />
      Besselstraße 13<br />
      10969 Berlin<br />
      <br />
      <a href="mailto:hello@akkurat.tv" className="link">hello@akkurat.tv</a>
    </div>
    <div className="column column--newsletter">
      <NewsletterForm />
    </div>
    <div className="column column--imprint">
        <a href="https://onefortysix.agency?utm_source=akkurat" target="_blank">
          Site by <OneFortySix />
        </a>
        &nbsp;&nbsp;&nbsp;
        <a href="/imprint.txt" target="_blank">
        Imprint
      </a>
    </div>
  </footer>;
};

export default Footer;
